function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M20.5,0H3.5A3.47,3.47,0,0,0,1,1.05a.38.38,0,0,0-.14.14A3.51,3.51,0,0,0,0,3.5v13a4.49,4.49,0,0,0,3.31,4.17L14.47,23.3a3.35,3.35,0,0,0,.76.09A2.75,2.75,0,0,0,17,22.81,2.87,2.87,0,0,0,18,20.5V18h2.5A3.5,3.5,0,0,0,24,14.5V3.5A3.5,3.5,0,0,0,20.5,0ZM17,20.5a1.79,1.79,0,0,1-2.31,1.83L3.53,19.7A3.5,3.5,0,0,1,1,16.5V3.5A2.44,2.44,0,0,1,1.49,2l13,3.24A3.56,3.56,0,0,1,17,8.5Zm6-6A2.5,2.5,0,0,1,20.5,17H18V9h1.5a.5.5,0,0,0,0-1H18a4.58,4.58,0,0,0-3.24-3.71L13.56,4H19.5a.5.5,0,0,0,0-1H9.56L2.46,1.23A2.43,2.43,0,0,1,3.5,1h17A2.5,2.5,0,0,1,23,3.5ZM13,11a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,13,11Zm0,4a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,13,15Z"
})));

var SvgTransactions = function SvgTransactions(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 23.39",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransactions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transactions.67475c2a.svg";
export { ForwardRef as ReactComponent };